export default __webpack_public_path__ + "maps-guides-view-annotation-simple-1200-f1cae6108815b6634bfdf4b9dcea0fc9.png";